import { toast } from "sonner";

import type { WindowsAdapter } from "../types";

const POPUP_FEATURES =
  "popup=yes,width=1280,height=800,resizable=yes,menubar=no,toolbar=no,location=no,status=no";

export const browserWindowsAdapter: WindowsAdapter = {
  openChartPopup({ symbol, timeframe, route }) {
    if (!symbol?.trim()) return;

    const params = new URLSearchParams({
      symbol: symbol.trim(),
      timeframe,
    });
    const path = route ?? `/chart-popup?${params.toString()}`;

    const w = window.open(path, "_blank", POPUP_FEATURES);
    if (w) {
      w.focus();
      return;
    }

    toast.error("Could not open chart window", {
      description:
        "Allow pop-ups for this site or try disabling the pop-up blocker.",
    });
  },

  isPopupWindow() {
    if (typeof window === "undefined") return false;
    return window.location.pathname.startsWith("/chart-popup");
  },
};
